import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import {
  takeUntil,
  delay,
  debounceTime,
  distinctUntilChanged,
  tap,
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';
import { SharedValidators, AppFilter, ConfirmModal } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import {
  UnitService,
  DepartmentService,
  OrganizationService,
} from '../../services';
interface IUserDepartmentUnitrModalContext {
  title: string;
  data?: any;
}
function check(data: Array<any>, users) {
  for (let i = 0; i < data.length; i++) {
    var node = data[i];
    data[i]['selected'] = users.indexOf(node['appUserId']) > -1 ? true : false;
    console.log(data[i]['selected']);
  }
  return data;
}

@Component({
  selector: 'app-user-department-uni-modal',
  templateUrl: './unit-user-modal.component.html',
  styleUrls: ['./unit-user-modal.component.scss'],
})
export class UserDepartmentUnitrModalComponent implements OnInit, OnDestroy {
  search: FormControl = new FormControl('');
  searchable: boolean = true;
  isUnit: boolean;
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  organizationId;
  departments;
  units;
  user;
  roles;
  unitId: string;
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private userService: OrganizationService,
    private unitSvc: UnitService,
    private modalService: SuiModalService,
    private departmentSvc: DepartmentService,
    public modal: SuiModal<IUserDepartmentUnitrModalContext, void, void>
  ) {
    this.user = modal.context.data.user;
    this.roles = modal.context.data.roles;

    this.organizationId = this.user.organizationId.organizationId;
    this.getDepartments();
    this.getUnits();
  }

  getDepartments() {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'organizationTypeId.organizationTypeId',
          op: 'ne',
          data: 'contractor',
        },
        {
          field: 'organizationShortName',
          op: 'cn',
          data: '',
        },
      ],
    };
    let filter = new AppFilter({ rows: 10000 });
    filter.filters = JSON.stringify(searchFilter);
    this.pending = true;
    this.departmentSvc
      .getDepartment({
        params: filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.departments = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getUnits() {
    this.pending = true;
    let filter = new AppFilter({ rows: 10000 });
    this.unitSvc
      .getUnit({
        organizationId: this.organizationId,
        params: filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.units = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  submitContinue() {
    let unit;
    this.pending = true;
    this.unitSvc
      .addUnitUser({
        organizationId: this.organizationId,
        organizationUnitId: this.unitId,
        body: { ids: [this.user.appUserId] },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User unit updated successfully';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  submit() {
    let unit;
    this.pending = true;
    this.departmentSvc
      .inviteExistingUser({
        organizationId: this.organizationId,
        body: {
          appUserId: this.user.appUserId,
          userRole: this.user.roleId.roleId,
        },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User department updated successfully';
          this.getDepartments();
          this.getUnits();
          this.unitId = this.user.organizationUnits[0]
            ? this.user.organizationUnits[0]['organizationUnitId']
            : '';
          this.isUnit = true;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  save() {
    this.modal.approve(null);
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class UserDepartmentUnitrModal extends ComponentModalConfig<
  IUserDepartmentUnitrModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(UserDepartmentUnitrModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
